import React from 'react';
import PropTypes from 'prop-types';
export default function IconDownload({ className }){
  return(
    <svg className={className} fill="none" height="14" viewBox="0 0 11 14" width="11" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.75 12H9.75C10.1642 12 10.5 12.3358 10.5 12.75C10.5 13.1297 10.2178 13.4435 9.85177 13.4932L9.75 13.5H0.75C0.335786 13.5 0 13.1642 0 12.75C0 12.3703 0.282154 12.0565 0.648229 12.0068L0.75 12H9.75H0.75ZM5.14823 0.00684667L5.25 0C5.6297 0 5.94349 0.282154 5.99315 0.648229L6 0.75V8.438L8.2552 6.18414C8.52147 5.91787 8.93813 5.89366 9.23175 6.11152L9.31586 6.18414C9.58213 6.4504 9.60634 6.86707 9.38848 7.16068L9.31586 7.2448L5.78033 10.7803C5.51406 11.0466 5.0974 11.0708 4.80379 10.8529L4.71967 10.7803L1.18414 7.2448C0.891243 6.9519 0.891243 6.47703 1.18414 6.18414C1.4504 5.91787 1.86707 5.89366 2.16068 6.11152L2.2448 6.18414L4.5 8.44V0.75C4.5 0.370304 4.78215 0.0565091 5.14823 0.00684667L5.25 0L5.14823 0.00684667Z" fill="currentColor"/>
    </svg>

  );
}
IconDownload.propTypes = {
  className: PropTypes.string
};
